import { render, staticRenderFns } from "./TourDescriptionTabs.vue?vue&type=template&id=5db69628"
import script from "./TourDescriptionTabs.js?vue&type=script&lang=js&external"
export * from "./TourDescriptionTabs.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports